module.exports = __webpack_public_path__ + "static/media/faico-connect-mobile.a9d7dac7.png";